module.exports = __webpack_public_path__ + "static/media/1.60e729c7.jpg";